import { jsx as _jsx, jsxs as _jsxs } from "@redneckz/uni-jsx/jsx-runtime";
import { JSX } from '@redneckz/uni-jsx';
import { Img } from '../../ui-kit/Img/Img.js';
import { Text } from '../../ui-kit/Text/Text.js';
import { style } from '../../utils/style.js';
const colorStyle = {
    yellow: { border: 'border-yellow-light', text: 'text-yellow' },
    green: { border: 'border-green-more-light', text: 'text-green-dark' },
    gray: { border: 'border-gray', text: 'text-secondary-text' },
    red: { border: 'border-error/30', text: 'text-error' },
};
export const Badge = JSX(({ className, children, color = 'gray' }) => (_jsxs("div", { className: style('sm:p-s sm:border sm:border-green rounded-md flex items-center h-fit', colorStyle[color].border, className), children: [_jsx("div", { className: "block pr-m sm:pr-0 sm:hidden", children: _jsx(Img, { image: { icon: 'SmallClockIcon' }, width: "24", height: "24" }) }), _jsx(Text, { size: "text-m", color: colorStyle[color].text, children: children })] })));
//# sourceMappingURL=Badge.js.map